import { render, staticRenderFns } from "./AddCpvModal.vue?vue&type=template&id=b49972fe&scoped=true&"
import script from "./AddCpvModal.vue?vue&type=script&lang=js&"
export * from "./AddCpvModal.vue?vue&type=script&lang=js&"
import style0 from "./AddCpvModal.vue?vue&type=style&index=0&id=b49972fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49972fe",
  null
  
)

export default component.exports